<template>
  <div class="common-count-down-dialog">
    <el-dialog
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :show-close="false"
      size="tiny"
      top="40%"
      :custom-class="$slots.default ? '' : 'toast-dialog'">
        <div class="dialog-title">
          {{ title }}
          <span class="left-time">{{ leftTime ? leftTime+'S' : '' }}</span>
        </div>
        <slot></slot>
        <div class="dialog-footer" v-if="showFooter">
          <button @click="onClose" class="btn">好的</button>
        </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'common-count-down-dialog',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    seconds: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(newValue) {
        this.$emit('update:visible', newValue);
      },
    },
  },
  data() {
    return {
      timer: null,
      leftTime: 0,
    };
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.leftTime = this.seconds || 0;
          this.init();
        }
      },
    },
  },
  destroyed() {
    this.clearTimer();
  },
  methods: {
    init() {
      this.timer = setInterval(() => {
        if (this.leftTime <= 0) {
          this.onClose();
          return;
        }
        this.leftTime--;
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 关闭对话框回调
    onClose() {
      this.innerVisible = false;
      this.$emit('close');
    },
  },
};
</script>

<style lang="less">
@import "../../../../assets/less/variable";
.common-count-down-dialog{
  .toast-dialog {
    .el-dialog__body {
      padding: 32px 0 32px 0;
    }
  }
  .el-dialog{
    width: 440px;
  }
  .el-dialog__body {
    padding: 60px 0 32px 0;
  }
 .el-dialog__header, 
 .el-dialog__footer {
    display: none;
  }

  .dialog-title {
    text-align: center;
    font-size: 24px;
    color: #2F333D;
    line-height: 24px;
    font-weight: 600;
    .left-time {
      margin-left: 4px;
    }
  }
  .dialog-footer {
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 40px;
    .btn {
      padding: 8px 54px;
      background: #599FFF;
      border-radius: 4px;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 32px;
      border-color: transparent;
      margin: 0 auto;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/modals/common-count-down-dialog/common-count-down-dialog.vue